// extracted by mini-css-extract-plugin
export default {"wrapper":"rM8ep","gallery":"PNVr8","arrows":"GQGfx","infoPopup":"_lStn","placeholder":"YtBtZ"};